import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { galleryImages } from '../data/mock';

const Gallery = () => {
  return (
    <div className="min-h-screen bg-zinc-950">
      {/* Hero Section */}
      <section className="relative py-20 bg-zinc-900">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <Badge className="bg-orange-500/20 text-orange-500 border-orange-500/50 mb-4">Gallery</Badge>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Our Work in Action
            </h1>
            <p className="text-xl text-gray-300">
              Take a look at our fleet and the projects we've completed across Adelaide Hills and Murray Bridge
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryImages.map((image) => (
              <Card 
                key={image.id} 
                className="bg-zinc-800 border-zinc-700 overflow-hidden group hover:border-orange-500 transition-all duration-300"
              >
                <CardContent className="p-0">
                  <div className="relative overflow-hidden aspect-video">
                    <img
                      src={image.url}
                      alt={image.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {galleryImages.length === 0 && (
            <div className="text-center py-20">
              <p className="text-gray-400 text-lg">No images to display yet.</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-zinc-900">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Want to See More?
            </h2>
            <p className="text-gray-400 text-lg mb-8">
              These are just some examples of our work. Contact us to discuss your project and see how we can help.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="#contact"
                className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-3 rounded-lg transition-all duration-300 shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50"
              >
                Get a Quote
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
